import styled from 'styled-components';

export const ModalNoAccessToStreamingStyle = styled.section`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => {
    return theme.colors.shadow;
  }};

  div {
    width: 70%;
    padding: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: ${({ theme }) => {
      return theme.colors.backgroundForm;
    }};
    border-radius: ${({ theme }) => {
      return theme.borderRadius.small;
    }};

    p {
      text-align: center;
      margin: 10px;
      font-size: ${({ theme }) => {
        return theme.fonts.size.big;
      }};
      font-weight: ${({ theme }) => {
        return theme.fonts.weight.normal;
      }};
      span {
        font-style: italic;
      }
    }

    label {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      button {
        font-size: ${({ theme }) => {
          return theme.fonts.size.normal;
        }};
        font-weight: 600;
        color: ${({ theme }) => {
          return theme.colors.error;
        }};
        border: ${({ theme }) => {
          return theme.border;
        }};
        border-color: ${({ theme }) => {
          return theme.colors.error;
        }};
        border-radius: ${({ theme }) => {
          return theme.borderRadius.small;
        }};
        background-color: ${({ theme }) => {
          return theme.colors.backgroundForm;
        }};
        cursor: pointer;
        transition: background-color 200ms ease-in-out;
        &:hover {
          background-color: ${({ theme }) => {
            return theme.colors.error;
          }};
          color: ${({ theme }) => {
            return theme.colors.backgroundForm;
          }};
        }
      }
    }
  }
`;
